import { render, staticRenderFns } from "./SubAllCategory.vue?vue&type=template&id=39987258&scoped=true&"
import script from "./SubAllCategory.vue?vue&type=script&lang=js&"
export * from "./SubAllCategory.vue?vue&type=script&lang=js&"
import style0 from "./SubAllCategory.vue?vue&type=style&index=0&id=39987258&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39987258",
  null
  
)

export default component.exports